// import Modal2 from '../modals/Modal2';
import React from 'react';
import './S3SuccessPopup.css';
import t from '../../../i18n/I18n';
import Modal from '../../../modals/Modal';

type S3SuccessPopupProps = {
  heading: string,
  subHeading: string,
  img: string,
  links: Array<object>,
  isS3Bucket: boolean
};
type S3ErrorPopupProps = {
  errorMsg: string,
  onClose: Function
};
export const S3SuccessPopup = function(props: S3SuccessPopupProps) {
  return (
    <center>
      <div name="S3-Success-Popup">
        <img className="successIcon" src={props.img} />
        <div className="S3-success_title">{props.heading}</div>
        <div className="s3-success-subHeading">{props.subHeading}</div>
        {props.links && props.links.length ? (
          <div className="S3_success_File">
            <div className="S3_link_title">{t('S3_FILES_LINK_TITLE')}</div>
            <div className="S3_link_subtitle">{t('S3_FILES_LINK_SUBTITLE')}</div>
            {props.links.map(FileNameLinks)}
          </div>
        ) : null}
      </div>
    </center>
  );
};

export const S3ErrorPopup = function(props: S3ErrorPopupProps) {
  return (
    <Modal onClose={props.onClose} zIndex={1000} closeOnEsc closeOnOutsideClick>
      <div
        style={{
          margin: 'auto',
          background: 'var(--primary-style-color)',
          padding: '20px',
          fontSize: '20px',
          color: 'var(--primary-header-bg)'
        }}>
        {props.errorMsg}
      </div>
    </Modal>
  );
};

const FileNameLinks = function(item, index) {
  return (
    <div key={'FILENAME_TO_LINK' + index}>
      <div className="S3_success_FileName">{item.fileName}</div>
      <a href={item.link} target="_blank">
        <div className="S3_success_FileLink">{item.link}</div>
      </a>
    </div>
  );
};
